/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Errors_Uploadfailed1Inputs */

const id_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah gagal`)
};

const ms_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat naik gagal`)
};

const da_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload mislykkedes`)
};

const de_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochladen fehlgeschlagen`)
};

const en_us2_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload failed`)
};

const es_es2_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al subir`)
};

const es_mx2_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al subir`)
};

const fil_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabigo ang upload`)
};

const fr_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du téléversement`)
};

const it_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento fallito`)
};

const hu_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sikertelen feltöltés`)
};

const nl_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploaden mislukt`)
};

const no_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opplasting mislyktes`)
};

const pl_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przesyłanie nie powiodło się`)
};

const pt_br2_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha no upload`)
};

const pt_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregamento falhou`)
};

const ro_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Încărcarea a eșuat`)
};

const fi_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataus epäonnistui`)
};

const sv_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppladdning misslyckades`)
};

const vi_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải lên thất bại`)
};

const tr_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yükleme başarısız`)
};

const cs_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrání se nezdařilo`)
};

const bg_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неуспешно качване`)
};

const ru_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить`)
};

const uk_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантаження не вдалося`)
};

const ar_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل التحميل`)
};

const hi_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपलोड विफल`)
};

const th_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปโหลดล้มเหลว`)
};

const ja_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロード失敗`)
};

const zh_cn2_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传失败`)
};

const zh_hant1_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上傳失敗`)
};

const ko_profile_errors_uploadfailed1 = /** @type {(inputs: Profile_Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업로드 실패`)
};

/**
* | output |
* | --- |
* | "Upload failed" |
*
* @param {Profile_Errors_Uploadfailed1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_errors_uploadfailed1 = /** @type {((inputs?: Profile_Errors_Uploadfailed1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Errors_Uploadfailed1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_errors_uploadfailed1(inputs)
	if (locale === "ms") return ms_profile_errors_uploadfailed1(inputs)
	if (locale === "da") return da_profile_errors_uploadfailed1(inputs)
	if (locale === "de") return de_profile_errors_uploadfailed1(inputs)
	if (locale === "en-US") return en_us2_profile_errors_uploadfailed1(inputs)
	if (locale === "es-ES") return es_es2_profile_errors_uploadfailed1(inputs)
	if (locale === "es-MX") return es_mx2_profile_errors_uploadfailed1(inputs)
	if (locale === "fil") return fil_profile_errors_uploadfailed1(inputs)
	if (locale === "fr") return fr_profile_errors_uploadfailed1(inputs)
	if (locale === "it") return it_profile_errors_uploadfailed1(inputs)
	if (locale === "hu") return hu_profile_errors_uploadfailed1(inputs)
	if (locale === "nl") return nl_profile_errors_uploadfailed1(inputs)
	if (locale === "no") return no_profile_errors_uploadfailed1(inputs)
	if (locale === "pl") return pl_profile_errors_uploadfailed1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_errors_uploadfailed1(inputs)
	if (locale === "pt") return pt_profile_errors_uploadfailed1(inputs)
	if (locale === "ro") return ro_profile_errors_uploadfailed1(inputs)
	if (locale === "fi") return fi_profile_errors_uploadfailed1(inputs)
	if (locale === "sv") return sv_profile_errors_uploadfailed1(inputs)
	if (locale === "vi") return vi_profile_errors_uploadfailed1(inputs)
	if (locale === "tr") return tr_profile_errors_uploadfailed1(inputs)
	if (locale === "cs") return cs_profile_errors_uploadfailed1(inputs)
	if (locale === "bg") return bg_profile_errors_uploadfailed1(inputs)
	if (locale === "ru") return ru_profile_errors_uploadfailed1(inputs)
	if (locale === "uk") return uk_profile_errors_uploadfailed1(inputs)
	if (locale === "ar") return ar_profile_errors_uploadfailed1(inputs)
	if (locale === "hi") return hi_profile_errors_uploadfailed1(inputs)
	if (locale === "th") return th_profile_errors_uploadfailed1(inputs)
	if (locale === "ja") return ja_profile_errors_uploadfailed1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_errors_uploadfailed1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_errors_uploadfailed1(inputs)
	return ko_profile_errors_uploadfailed1(inputs)
});
export { profile_errors_uploadfailed1 as "profile.errors.uploadFailed" }